import type React from "react";
import { useEffect, useRef } from "react";

import WordCloud from "wordcloud";

interface ITagsCloudProps {
    tags: Array<{ Name: string; Value: number }>;
}

export const WordsCloud: React.FC<ITagsCloudProps> = ({ tags }) => {
    // Create a ref to hold the element
    const wordsContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Make sure WordCloud is only rendered after the component is mounted
        if (wordsContainerRef.current && tags.length > 1) {
            // Normalize the weights
            const filteredTags = tags.slice(1);
            const maxValue = Math.max(...filteredTags.map((tag) => tag.Value));
            const words = filteredTags.map((tag) => [tag.Name, (tag.Value / maxValue) * 38]);
            const options = {
                list: words, // Transform words into the required format
                gridSize: 16, // this controls the word spacing
                minSize: 6, // Minimum font size
                shape: "circle", // Shape of the word cloud
                fontFamily: "Roboto, sans-serif",
                color: "3a5166",
                rotateRatio: 0,
                rotationSteps: 2,
            };
            // Initialize WordCloud
            WordCloud(wordsContainerRef.current, options);
        }
    }, [tags]); // Redraw when words change
    return (
        <div
            ref={wordsContainerRef}
            style={{ width: "100%", height: "200px" }}
        />
    );
};
